// tslint:disable:max-line-length
import * as React from "react";
import { iconStyle } from "./icon.style";
interface IProps {
  style?: React.CSSProperties;
}
export const CalendarIcon: React.FC<IProps> = (props) => (
  <svg
    id="icons"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    style={{ ...iconStyle, ...props.style }}
  >
    <path d="M20,3h-2v-1c0-.55-.45-1-1-1s-1,.45-1,1v1h-8v-1c0-.55-.45-1-1-1s-1,.45-1,1v1h-2c-1.65,0-3,1.35-3,3v14c0,1.65,1.35,3,3,3h16c1.65,0,3-1.35,3-3V6c0-1.65-1.35-3-3-3ZM4,5h2v1c0,.55.45,1,1,1s1-.45,1-1v-1h8v1c0,.55.45,1,1,1s1-.45,1-1v-1h2c.55,0,1,.45,1,1v3H3v-3c0-.55.45-1,1-1ZM20,21H4c-.55,0-1-.45-1-1v-9h18v9c0,.55-.45,1-1,1ZM13.5,14c0,.55-.45,1-1,1h-1c-.55,0-1-.45-1-1s.45-1,1-1h1c.55,0,1,.45,1,1ZM8,14c0,.55-.45,1-1,1h-1c-.55,0-1-.45-1-1s.45-1,1-1h1c.55,0,1,.45,1,1ZM13.5,18c0,.55-.45,1-1,1h-1c-.55,0-1-.45-1-1s.45-1,1-1h1c.55,0,1,.45,1,1ZM8,18c0,.55-.45,1-1,1h-1c-.55,0-1-.45-1-1s.45-1,1-1h1c.55,0,1,.45,1,1ZM19,14c0,.55-.45,1-1,1h-1c-.55,0-1-.45-1-1s.45-1,1-1h1c.55,0,1,.45,1,1Z" />
  </svg>
);



// WEBPACK FOOTER //
// ./src/icons/Calendar.tsx